import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageCTA = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14920)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M176.908 41.8522V114.831C176.908 117.251 175.946 119.571 174.236 121.282C172.525 122.993 170.205 123.954 167.785 123.954H81.1224C78.703 123.954 76.3827 122.993 74.6719 121.282C72.9611 119.571 72 117.251 72 114.831V41.8522H176.908Z"
            fill="#66E1FF"
          />
          <path
            d="M72.0462 41.8522V114.831C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H85.7298L167.831 41.8522H72.0462Z"
            fill="#C2F3FF"
          />
          <path
            d="M176.954 41.8523H72.0462V28.1687C72.0462 25.7493 73.0073 23.4289 74.7181 21.7182C76.4289 20.0074 78.7492 19.0463 81.1686 19.0463H167.831C170.251 19.0463 172.571 20.0074 174.282 21.7182C175.993 23.4289 176.954 25.7493 176.954 28.1687V41.8523Z"
            fill="white"
          />
          <path
            d="M167.831 19.0463H81.1686C78.7492 19.0463 76.4289 20.0074 74.7181 21.7182C73.0073 23.4289 72.0462 25.7493 72.0462 28.1687V114.831C72.0462 117.251 73.0073 119.571 74.7181 121.282C76.4289 122.993 78.7492 123.954 81.1686 123.954H167.831C170.251 123.954 172.571 122.993 174.282 121.282C175.993 119.571 176.954 117.251 176.954 114.831V28.1687C176.954 25.7493 175.993 23.4289 174.282 21.7182C172.571 20.0074 170.251 19.0463 167.831 19.0463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.0462 41.8522H176.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.0104 31.5896C87.708 31.5896 87.418 31.4694 87.2041 31.2556C86.9903 31.0417 86.8701 30.7517 86.8701 30.4493C86.8701 30.1468 86.9903 29.8568 87.2041 29.6429C87.418 29.4291 87.708 29.309 88.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M88.0104 31.5896C88.3128 31.5896 88.6028 31.4694 88.8167 31.2556C89.0305 31.0417 89.1507 30.7517 89.1507 30.4493C89.1507 30.1468 89.0305 29.8568 88.8167 29.6429C88.6028 29.4291 88.3128 29.309 88.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M160.99 50.8275H88.0105C87.4056 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7299 52.5033 85.7299 53.1081V62.2305C85.7299 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4056 64.5111 88.0105 64.5111H160.99C161.594 64.5111 162.175 64.2708 162.602 63.8431C163.03 63.4154 163.27 62.8354 163.27 62.2305V53.1081C163.27 52.5033 163.03 51.9232 162.602 51.4955C162.175 51.0678 161.594 50.8275 160.99 50.8275Z"
            fill="#FFEF5E"
          />
          <path
            d="M88.0105 50.8275C87.4056 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7299 52.5033 85.7299 53.1081V62.2305C85.7299 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4056 64.5111 88.0105 64.5111H140.464L154.148 50.8275H88.0105Z"
            fill="#FFF9BF"
          />
          <path
            d="M160.99 50.8275H88.0105C87.4056 50.8275 86.8255 51.0678 86.3978 51.4955C85.9701 51.9232 85.7299 52.5033 85.7299 53.1081V62.2305C85.7299 62.8354 85.9701 63.4154 86.3978 63.8431C86.8255 64.2708 87.4056 64.5111 88.0105 64.5111H160.99C161.594 64.5111 162.175 64.2708 162.602 63.8431C163.03 63.4154 163.27 62.8354 163.27 62.2305V53.1081C163.27 52.5033 163.03 51.9232 162.602 51.4955C162.175 51.0678 161.594 50.8275 160.99 50.8275Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.961 74.208H88.4814C88.0444 74.208 87.6252 74.3816 87.3162 74.6907C87.0071 74.9997 86.8335 75.4189 86.8335 75.8559V89.0393C86.8335 89.4763 87.0071 89.8955 87.3162 90.2045C87.6252 90.5136 88.0444 90.6872 88.4814 90.6872H104.961C105.398 90.6872 105.817 90.5136 106.126 90.2045C106.435 89.8955 106.608 89.4763 106.608 89.0393V75.8559C106.608 75.4189 106.435 74.9997 106.126 74.6907C105.817 74.3816 105.398 74.208 104.961 74.208Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3613 74.6456L106.082 90.2481"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.3613 90.2481L106.082 74.6456"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 76.5625H163.417"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.805 85.6846H154"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.694 31.5896C101.392 31.5896 101.102 31.4694 100.888 31.2556C100.674 31.0417 100.554 30.7517 100.554 30.4493C100.554 30.1468 100.674 29.8568 100.888 29.6429C101.102 29.4291 101.392 29.309 101.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M101.694 31.5896C101.996 31.5896 102.286 31.4694 102.5 31.2556C102.714 31.0417 102.834 30.7517 102.834 30.4493C102.834 30.1468 102.714 29.8568 102.5 29.6429C102.286 29.4291 101.996 29.309 101.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5896C115.075 31.5896 114.785 31.4694 114.571 31.2556C114.357 31.0417 114.237 30.7517 114.237 30.4493C114.237 30.1468 114.357 29.8568 114.571 29.6429C114.785 29.4291 115.075 29.309 115.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M115.378 31.5896C115.68 31.5896 115.97 31.4694 116.184 31.2556C116.398 31.0417 116.518 30.7517 116.518 30.4493C116.518 30.1468 116.398 29.8568 116.184 29.6429C115.97 29.4291 115.68 29.309 115.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M97 100C97 98.8954 97.8954 98 99 98H187C188.105 98 189 98.8954 189 100V117.058C189 118.163 188.105 119.058 187 119.058H99C97.8954 119.058 97 118.163 97 117.058V100Z"
            fill="black"
          />
          <path
            d="M119.105 110.674H120.799C120.771 111.158 120.633 111.582 120.383 111.945C120.133 112.309 119.787 112.592 119.346 112.795C118.904 112.994 118.385 113.094 117.787 113.094C117.299 113.094 116.863 113.018 116.48 112.865C116.102 112.713 115.779 112.492 115.514 112.203C115.248 111.914 115.045 111.564 114.904 111.154C114.768 110.744 114.699 110.279 114.699 109.76V109.42C114.699 108.9 114.771 108.436 114.916 108.025C115.061 107.611 115.268 107.26 115.537 106.971C115.807 106.682 116.129 106.461 116.504 106.309C116.879 106.152 117.299 106.074 117.764 106.074C118.396 106.074 118.93 106.182 119.363 106.396C119.801 106.611 120.139 106.906 120.377 107.281C120.619 107.652 120.762 108.076 120.805 108.553H119.117C119.105 108.334 119.055 108.139 118.965 107.967C118.875 107.791 118.732 107.652 118.537 107.551C118.346 107.449 118.088 107.398 117.764 107.398C117.537 107.398 117.338 107.439 117.166 107.521C116.994 107.604 116.85 107.729 116.732 107.896C116.619 108.064 116.533 108.275 116.475 108.529C116.416 108.779 116.387 109.074 116.387 109.414V109.76C116.387 110.104 116.412 110.402 116.463 110.656C116.518 110.91 116.602 111.121 116.715 111.289C116.828 111.453 116.973 111.576 117.148 111.658C117.328 111.74 117.541 111.781 117.787 111.781C118.068 111.781 118.305 111.742 118.496 111.664C118.688 111.582 118.834 111.459 118.936 111.295C119.037 111.131 119.094 110.924 119.105 110.674ZM126.488 111.682V113H122.773V111.682H126.488ZM123.371 106.174V113H121.684V106.174H123.371ZM129.078 106.174V113H127.385V106.174H129.078ZM134.562 110.674H136.256C136.229 111.158 136.09 111.582 135.84 111.945C135.59 112.309 135.244 112.592 134.803 112.795C134.361 112.994 133.842 113.094 133.244 113.094C132.756 113.094 132.32 113.018 131.938 112.865C131.559 112.713 131.236 112.492 130.971 112.203C130.705 111.914 130.502 111.564 130.361 111.154C130.225 110.744 130.156 110.279 130.156 109.76V109.42C130.156 108.9 130.229 108.436 130.373 108.025C130.518 107.611 130.725 107.26 130.994 106.971C131.264 106.682 131.586 106.461 131.961 106.309C132.336 106.152 132.756 106.074 133.221 106.074C133.854 106.074 134.387 106.182 134.82 106.396C135.258 106.611 135.596 106.906 135.834 107.281C136.076 107.652 136.219 108.076 136.262 108.553H134.574C134.562 108.334 134.512 108.139 134.422 107.967C134.332 107.791 134.189 107.652 133.994 107.551C133.803 107.449 133.545 107.398 133.221 107.398C132.994 107.398 132.795 107.439 132.623 107.521C132.451 107.604 132.307 107.729 132.189 107.896C132.076 108.064 131.99 108.275 131.932 108.529C131.873 108.779 131.844 109.074 131.844 109.414V109.76C131.844 110.104 131.869 110.402 131.92 110.656C131.975 110.91 132.059 111.121 132.172 111.289C132.285 111.453 132.43 111.576 132.605 111.658C132.785 111.74 132.998 111.781 133.244 111.781C133.525 111.781 133.762 111.742 133.953 111.664C134.145 111.582 134.291 111.459 134.393 111.295C134.494 111.131 134.551 110.924 134.562 110.674ZM138.828 106.174V113H137.141V106.174H138.828ZM143.176 106.174L140.357 109.666L138.758 111.236L138.33 109.73L139.414 108.283L141.061 106.174H143.176ZM141.236 113L139.268 109.947L140.568 108.992L143.24 113H141.236ZM151.666 108.992V110.311H147.863V108.992H151.666ZM148.414 106.174V113H146.727V106.174H148.414ZM152.814 106.174V113H151.127V106.174H152.814ZM158.996 111.682V113H155.07V111.682H158.996ZM155.668 106.174V113H153.98V106.174H155.668ZM158.492 108.811V110.129H155.07V108.811H158.492ZM159.002 106.174V107.498H155.07V106.174H159.002ZM159.752 106.174H162.605C163.027 106.174 163.408 106.219 163.748 106.309C164.088 106.395 164.377 106.523 164.615 106.695C164.857 106.867 165.043 107.082 165.172 107.34C165.301 107.594 165.365 107.889 165.365 108.225C165.365 108.623 165.299 108.955 165.166 109.221C165.033 109.486 164.85 109.703 164.615 109.871C164.381 110.039 164.109 110.18 163.801 110.293L163.238 110.621H160.812L160.801 109.303H162.617C162.852 109.303 163.047 109.268 163.203 109.197C163.359 109.123 163.477 109.018 163.555 108.881C163.633 108.744 163.672 108.582 163.672 108.395C163.672 108.203 163.631 108.041 163.549 107.908C163.467 107.775 163.346 107.674 163.186 107.604C163.029 107.533 162.836 107.498 162.605 107.498H161.445V113H159.752V106.174ZM163.801 113L162.166 109.988L163.959 109.971L165.623 112.93V113H163.801ZM171.5 111.682V113H167.574V111.682H171.5ZM168.172 106.174V113H166.484V106.174H168.172ZM170.996 108.811V110.129H167.574V108.811H170.996ZM171.506 106.174V107.498H167.574V106.174H171.506Z"
            fill="white"
          />
          <path
            d="M192.558 125.542C192.806 126.138 192.567 128.397 191.25 128.92C189.933 129.444 188.249 128.92 188.249 128.92L185.195 122.812L179.917 128.09V104.25L196.087 120.42H190.062C190.358 120.987 192.242 124.784 192.558 125.542Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.333 107.67V124.67L185.583 120.42L189.125 127.503C189.125 127.503 190.083 127.809 190.542 127.503C191 127.198 191.456 126.582 191.25 126.087C190.276 123.749 187.708 119.003 187.708 119.003H192.667L181.333 107.67Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14920">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
